import React from 'react';
import { Link } from 'react-router-dom';
import { imageUrl } from '../lib/images';
import SparklePattern from './SparklePattern';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative bg-white text-slate-900 mt-auto border-t border-slate-200 overflow-hidden isolate">
      <SparklePattern variant="blue" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 [@media(min-width:1200px)]:grid-cols-4 gap-10 [@media(min-width:1200px)]:gap-8">
          {/* Brand & Identity */}
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <img
                src={imageUrl('/_assets/imgi-1-ma-standard-e42lzl.jpg', 'height=320,format=auto')}
                alt="MA Hvidevareservice logo"
                className="h-32 md:h-40 w-auto object-contain rounded-none p-0"
              />
            </div>
            <p className="text-sm text-slate-600 leading-relaxed">
              Din lokale specialist i service og reparation af hårde hvidevarer. 10 års erfaring på alle kendte mærker.
            </p>
            <div className="pt-1">
              <a
                href="https://www.facebook.com/people/MA-hvidevareservice/61563162135341/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-xs font-semibold text-slate-700 hover:text-sky-600 transition-colors"
                aria-label="Besøg MA Hvidevareservice på Facebook"
              >
                <i className="fa-brands fa-facebook text-base text-sky-600" aria-hidden="true" />
                <span>Følg os på Facebook</span>
              </a>
            </div>
          </div>

          {/* Kontakt & Adresse */}
          <div className="space-y-3">
            <h4 className="text-xs font-bold text-sky-600">
              Kontaktoplysninger
            </h4>
            <div className="space-y-2.5 text-sm text-slate-700">
              <p className="flex items-start gap-2.5">
                <i className="fa-solid fa-location-dot mt-1 text-slate-400 text-xs" aria-hidden="true" />
                <span>
                  Ruten 75, 1. th.<br />
                  2700 Brønshøj
                </span>
              </p>
              <p className="flex items-center gap-2.5">
                <i className="fa-solid fa-phone text-slate-400 text-xs" aria-hidden="true" />
                <a
                  href="tel:69306445"
                  className="hover:text-sky-600 transition-colors font-medium whitespace-nowrap"
                >
                  69 30 64 45
                </a>
              </p>
              <p className="flex items-center gap-2.5">
                <i className="fa-solid fa-envelope text-slate-400 text-xs" aria-hidden="true" />
                <a
                  href="mailto:mahvidevareservice@gmail.com"
                  className="hover:text-sky-600 transition-colors font-medium whitespace-nowrap"
                >
                  mahvidevareservice@gmail.com
                </a>
              </p>
              <p className="flex items-center gap-2.5 text-xs text-slate-500 pt-1">
                <span className="font-semibold text-slate-700">CVR:</span>
                <span>46308409</span>
              </p>
            </div>
          </div>

          {/* Hurtig Navigation */}
          <div className="space-y-3">
            <h4 className="text-xs font-bold text-sky-600">
              Navigation
            </h4>
            <ul className="space-y-2 text-sm text-slate-700">
              <li>
                <Link to="/" className="hover:text-sky-600 transition-colors">
                  Forside
                </Link>
              </li>
              <li>
                <Link to="/service-priser" className="hover:text-sky-600 transition-colors">
                  Service & Priser
                </Link>
              </li>
              <li>
                <Link to="/om-mig" className="hover:text-sky-600 transition-colors">
                  Om mig (Mikki)
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="hover:text-sky-600 transition-colors">
                  Kontakt
                </Link>
              </li>
            </ul>
          </div>

          {/* Åbningstider fra scrape */}
          <div className="space-y-3">
            <h4 className="text-xs font-bold text-sky-600">
              Åbningstider
            </h4>
            <ul className="space-y-2 text-sm text-slate-700">
              <li className="flex justify-between items-center text-xs pb-1">
                <span className="text-slate-500">Mandag – torsdag:</span>
                <span className="font-medium text-slate-800">kl. 07.30 - 16.00</span>
              </li>
              <li className="flex justify-between items-center text-xs pb-1">
                <span className="text-slate-500">Fredag:</span>
                <span className="font-medium text-slate-800">kl. 08.00 - 14.30</span>
              </li>
              <li className="flex justify-between items-center text-xs pb-1">
                <span className="text-slate-500">Lørdag:</span>
                <span className="font-medium text-slate-800">Efter aftale</span>
              </li>
              <li className="flex justify-between items-center text-xs">
                <span className="text-slate-500">Søndag:</span>
                <span className="font-medium text-slate-400">Lukket</span>
              </li>
            </ul>
            <p className="text-[11px] text-slate-500 pt-1 leading-snug">
              Hurtig udrykning og ofte hjemmebesøg inden for 1 dag. Du kontaktes 20 min. før ankomst.
            </p>
          </div>
        </div>

        {/* Bottom copyright bar - NO cookie policy or privacy policy per requirements */}
        <div className="mt-12 pt-6 border-t border-slate-200 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-slate-500">
          <p>© {currentYear} MA Hvidevareservice. CVR: 46308409. Alle rettigheder forbeholdes.</p>
          <div className="flex items-center gap-4">
            <span className="whitespace-nowrap">Ruten 75, 1. th., 2700 Brønshøj</span>
            <span>•</span>
            <a href="tel:69306445" className="hover:text-slate-700 transition-colors whitespace-nowrap">
              Tlf: 69 30 64 45
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
